"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  slides: _propTypes["default"].arrayOf(_propTypes["default"].object),
  className: _propTypes["default"].string,
  autoplay: _propTypes["default"].bool,
  autoplaySpeed: _propTypes["default"].number,
  cyclical: _propTypes["default"].bool
});
var _default = exports["default"] = PROP_TYPES;